// Everything that changes with each monthly release, in one place (same file as in the
// Android app). A new comic itself still needs its entry in data/comics.js, its buy link
// in pages/Home.js and its code hash in Supabase (public.redeemable_codes).
// CHANGELOG is only shown by the Android app.

// The comic(s) of the month, shown first on the home. They are left out of the library
// while they are here.
export const FEATURED_IDS = [22];

// The library, in the order it is shown: these ids first, then every other comic from
// newest to oldest. When a comic stops being featured, add its id here (after 2, the
// free one) so it joins the library on top.
export const LIBRARY_FIRST_IDS = [2, 23, 21, 20, 19, 17, 18, 16, 15, 0, 14, 1];

// The "this month on Patreon" slider. Images go in public/.
export const PATREON_LABEL = 'October on Patreon';
export const PATREON_SLIDES = [
  { src: '/october_koichi_knuckleduster.jpg',     name: 'Koichi and Knuckleduster' },
  { src: '/october_future_trunks_17.jpg',         name: 'Future Trunks and 17' },
  { src: '/october_rob_lucci_zoro.jpg',           name: 'Rob Lucci and Zoro' },
  { src: '/october_ozai.jpg',                     name: 'Ozai' },
  { src: '/october_jin_kagemori_tadera_ryu.jpg',  name: 'Jin Kagemori and Tadera Ryu' },
  { src: '/october_shinichi_kudo.jpg',            name: 'Shinichi Kudo' },
];

// Cover of next month's comic (the spinning card, already out for the Master tier).
export const PROMO_IMAGE = '/promo_next_month.jpg';

// "What's new", newest first, shown in Updates above the older entries. Add the new
// version on top.
export const CHANGELOG = [
  {
    version: '1.5.6',
    subtitle: 'Update – New comic and a brand-new look.',
    sections: [
      { title: '🆕 New Comics', items: ['Before returning to the future', 'A short story in the locker room'] },
      {
        title: '✨ New Features',
        items: [
          'Brand-new comic-style design for the whole app',
          'Automatic updates — the app tells you when a new version is out and installs it',
          'Forgot your password? You can now reset it from the login screen',
        ],
      },
      { title: '🛠️ Fixes', items: ['Comics unlocked with your account now always open in the reader'] },
    ],
  },
  {
    version: '1.5.5',
    subtitle: 'Patch – New comic and new feature.',
    sections: [
      { title: '🆕 New Comics', items: ["Nagi's decision"] },
      { title: '✨ New Features', items: ['New user login screen — sign in to sync your unlocked comics across devices'] },
    ],
  },
];
